import { applySpec } from 'ramda';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { RootState } from '../store/types';

type DispatchReturnType = ReturnType<typeof useDispatch>;
type SpecFunction = (state: RootState) => any;

type UseAppStateRecord = <T extends Record<string, SpecFunction>>(
  spec: T
) => [Record<keyof T, ReturnType<T[keyof T]>>, DispatchReturnType];

type UseAppStateFunction = <T extends SpecFunction>(
  spec: T
) => [ReturnType<T>, DispatchReturnType];

export const useAppState: UseAppStateRecord & UseAppStateFunction = (
  spec: SpecFunction | Record<string, SpecFunction>
): [any, DispatchReturnType] => {
  const selectorsFunc: SpecFunction = typeof spec === 'function' ? spec : applySpec(spec);

  const dispatch = useDispatch();
  const state = useSelector(selectorsFunc, shallowEqual);

  return [ state, dispatch ];
};

export default useAppState;
